import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import SpectrumProvider from '@react/react-spectrum/Provider'
import { ApolloProvider } from '@apollo/client'

import apolloClient from '../services/apollo'
import { RootContextProvider } from './RootContext'
import { ProfileContextProvider } from './ProfileContext'
import { ScannerContextProvider } from './ScannerContext'

import App from '../views/App'

import { PATHS } from '../config/constants'

import './Root.scss'

const url = new URL(window.location.href)
const tokenFromURL = url.searchParams.get('token')
if (tokenFromURL) {
  document.cookie = `shared-token=${tokenFromURL};expires=;path=/`
}

export default () => {
  return (
    <ApolloProvider client={apolloClient}>
      <SpectrumProvider theme='light'>
        <BrowserRouter basename={PATHS.BASE}>
          <RootContextProvider>
            <ProfileContextProvider>
              <ScannerContextProvider>
                <Route
                  path={`${process.env.REACT_APP_ROOT_PATH}/:projectID/:entityIdNS?/:entityId?`}
                  render={(props) => {
                    return (
                      <App
                        projectID={props.match.params.projectID}
                        entityIdNS={props.match.params.entityIdNS}
                        entityId={props.match.params.entityId}
                      ></App>
                    )
                  }}
                />
              </ScannerContextProvider>
            </ProfileContextProvider>
          </RootContextProvider>
        </BrowserRouter>
      </SpectrumProvider>
    </ApolloProvider>
  )
}
